<script>
  import { getContext } from "svelte";
  import { countryStore } from "../store/Countries.js";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  function closeModal() {
    close();
  }

  let currencies = [];

  async function getCurrencies() {
    currencies = await countryStore.getCurrencies();
  }
  getCurrencies();

  export let country = { nameKey: "", currencyId: 1 };
  async function save() {
    if (country.nameKey == "") {
      snackbar("info", "Fill in a name translation key for the country");
      return;
    }
    var result = await countryStore.saveCountry(country);
    if (result.success) {
      snackbar("info", "Country saved");
      close();
    } else {
      snackbar("error", result.message);
    }
  }

  function init(element) {
    element.focus();
  }
</script>

<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">Country</h5>
</div>
<div class="modal-body">
  <label for="naam">Country name translation key</label>
  <input
    type="text"
    class="form-control"
    placeholder="country name translation key "
    bind:value={country.nameKey}
    use:init
    required=""
    id="naam"
  />
  <label for="naam">Currency</label>
  <select bind:value={country.currencyId}>
    {#each currencies as currency}
      <option value={currency.id}>{currency.nameKey}</option>
    {/each}
  </select>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" on:click={closeModal}>
    Close
  </button>
  <button type="button" class="btn btn-primary" on:click={save}>Save</button>
</div>
